import React from 'react'
import { useParams } from 'react-router-dom'
import { Formik, Form } from 'formik'

import {
  SuperEndDrySchema,
  initialSuperEndDryValues,
} from '../../utils/validation/superEndDry.js'
import { useSideNav } from '../../contexts/SideNavOpenContext.js'
import { useRecordLock } from '../../contexts/RecordLockContext'
import useSuperEnd from '../../hooks/useSuperEnd'

import ActionBar from '../shared/ActionBar.js'

import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'

import { DatePicker } from '@mui/x-date-pickers/DatePicker'

const SuperMidDry = () => {
  const { id } = useParams()
  const { sideNavOpen } = useSideNav(true)
  const { recordLock, setRecordLock } = useRecordLock()
  const { getSuperEndDraft, patchSuperEndDryDraft } = useSuperEnd({ id })

  const handleSave = (values, { setSubmitting }) => {
    patchSuperEndDryDraft.mutate(values)
    setSubmitting(false)
    setRecordLock(true)
  }

  const handleChange = (e, values, setValues) => {
    const name = e.target.name
    const value = e.target.value
    setValues({ ...values, [name]: value })
  }

  const handleDateChange = (name, value, values, setValues) => {
    setValues({ ...values, [name]: value })
  }
  return (
    <>
      <Formik
        initialValues={{
          ...initialSuperEndDryValues,
          ...getSuperEndDraft?.data,
        }}
        validationSchema={SuperEndDrySchema}
        onSubmit={(values, { setSubmitting }) =>
          handleSave(values, { setSubmitting })
        }
        enableReinitialize
      >
        {({
          isSubmitting,
          handleSubmit,
          values,
          touched,
          errors,
          setValues,
        }) => (
          <>
            <Form id={`SuperMidDry${id}`} onSubmit={handleSubmit}>
              <Grid
                container
                justifyContent='center'
                alignItems='center'
                sx={{
                  pt: '70px',
                  pr: '10px',
                  pb: '100px',
                  pl: sideNavOpen ? '260px' : '60px',
                }}
              >
                <Grid item xs={3}></Grid>
                <Grid item xs={9}>
                  <Typography variant='h1'>
                    Supervisor End Shift Passdown Dry Side
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Name
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryName'
                    disabled={true}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryName}
                    error={touched.dryName && !!errors.dryName}
                    helperText={touched.dryName && errors.dryName}
                  />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={9}>
                  <span style={{ color: 'red' }}>
                    * Note: Wet and Dry Start Date and Shift must match in order
                    for email to be sent
                  </span>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Date Shift Started{' '}
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <DatePicker
                    name='dryDate'
                    disabled={recordLock}
                    onChange={(value) =>
                      handleDateChange('dryDate', value, values, setValues)
                    }
                    value={values.dryDate}
                    error={touched.dryDate && !!errors.dryDate}
                    helperText={touched.dryDate && errors.dryDate}
                    renderInput={(params) => (
                      <TextField fullWidth size='small' {...params} />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Shift
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='dryShift'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryShift}
                    error={touched.dryShift && !!errors.dryShift}
                    helperText={touched.dryShift && errors.dryShift}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='A Day'>A Day</MenuItem>
                    <MenuItem value='A Night'>A Night</MenuItem>
                    <MenuItem value='B Day'>B Day</MenuItem>
                    <MenuItem value='B Night'>B Night</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Message From Sender
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryMessage'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryMessage}
                    error={touched.dryMessage && !!errors.dryMessage}
                    helperText={touched.dryMessage && errors.dryMessage}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    PASSDOWN
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Alarm Notice or Shutdown
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryAlarmNotice'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryAlarmNotice}
                    error={touched.dryAlarmNotice && !!errors.dryAlarmNotice}
                    helperText={touched.dryAlarmNotice && errors.dryAlarmNotice}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    # Broken State Seals
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryBrokenStateSeals'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryBrokenStateSeals}
                    error={
                      touched.dryBrokenStateSeals &&
                      !!errors.dryBrokenStateSeals
                    }
                    helperText={
                      touched.dryBrokenStateSeals && errors.dryBrokenStateSeals
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    EVAPORATOR
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Evaporator Comments
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='evapComments'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapComments}
                    error={touched.evapComments && !!errors.evapComments}
                    helperText={touched.evapComments && errors.evapComments}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Current Turbo Fan %
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='evapCurrentTurboFan'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapCurrentTurboFan}
                    error={
                      touched.evapCurrentTurboFan &&
                      !!errors.evapCurrentTurboFan
                    }
                    helperText={
                      touched.evapCurrentTurboFan && errors.evapCurrentTurboFan
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Pallet IDs Reconed on Shift
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='palletIdsReconedOnShift'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.palletIdsReconedOnShift}
                    error={
                      touched.palletIdsReconedOnShift &&
                      !!errors.palletIdsReconedOnShift
                    }
                    helperText={
                      touched.palletIdsReconedOnShift &&
                      errors.palletIdsReconedOnShift
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    3 Pallets Reconed? (Y/N)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='threePalletsReconed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.threePalletsReconed}
                    error={
                      touched.threePalletsReconed &&
                      !!errors.threePalletsReconed
                    }
                    helperText={
                      touched.threePalletsReconed && errors.threePalletsReconed
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Y'>Y</MenuItem>
                    <MenuItem value='N'>N</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    If "No", why not?
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='threePalletsReconedWhyNot'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.threePalletsReconedWhyNot}
                    error={
                      touched.threePalletsReconedWhyNot &&
                      !!errors.threePalletsReconedWhyNot
                    }
                    helperText={
                      touched.threePalletsReconedWhyNot &&
                      errors.threePalletsReconedWhyNot
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Recon Equipment Clean (Y/N)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='reconEquipmentClean'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.reconEquipmentClean}
                    error={
                      touched.reconEquipmentClean &&
                      !!errors.reconEquipmentClean
                    }
                    helperText={
                      touched.reconEquipmentClean && errors.reconEquipmentClean
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Y'>Y</MenuItem>
                    <MenuItem value='N'>N</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Recon Rm Clean (Y/N)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='reconRmClean'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.reconRmClean}
                    error={touched.reconRmClean && !!errors.reconRmClean}
                    helperText={touched.reconRmClean && errors.reconRmClean}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Y'>Y</MenuItem>
                    <MenuItem value='N'>N</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Recon Drain Line Empty (Y/N)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='reconDrainLineEmpty'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.reconDrainLineEmpty}
                    error={
                      touched.reconDrainLineEmpty &&
                      !!errors.reconDrainLineEmpty
                    }
                    helperText={
                      touched.reconDrainLineEmpty && errors.reconDrainLineEmpty
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Y'>Y</MenuItem>
                    <MenuItem value='N'>N</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    If "No" to any of the above three questions, why not?
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='reconCleanWhyNot'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.reconCleanWhyNot}
                    error={
                      touched.reconCleanWhyNot && !!errors.reconCleanWhyNot
                    }
                    helperText={
                      touched.reconCleanWhyNot && errors.reconCleanWhyNot
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Total City Water Flow
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='cityWaterFlow'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.cityWaterFlow}
                    error={touched.cityWaterFlow && !!errors.cityWaterFlow}
                    helperText={touched.cityWaterFlow && errors.cityWaterFlow}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Water Silo Washed (min 1/shift)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='waterSiloWashed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.waterSiloWashed}
                    error={touched.waterSiloWashed && !!errors.waterSiloWashed}
                    helperText={
                      touched.waterSiloWashed && errors.waterSiloWashed
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    HIST Regulatory Issues? (Y/N)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='evapHistRegulatoryIssues'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapHistRegulatoryIssues}
                    error={
                      touched.evapHistRegulatoryIssues &&
                      !!errors.evapHistRegulatoryIssues
                    }
                    helperText={
                      touched.evapHistRegulatoryIssues &&
                      errors.evapHistRegulatoryIssues
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Y'>Y</MenuItem>
                    <MenuItem value='N'>N</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    DRYER
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Dryer Comments
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryerComments'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryerComments}
                    error={touched.dryerComments && !!errors.dryerComments}
                    helperText={touched.dryerComments && errors.dryerComments}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    MPC Dryer Comments
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcDryerComments'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcDryerComments}
                    error={
                      touched.mpcDryerComments && !!errors.mpcDryerComments
                    }
                    helperText={
                      touched.mpcDryerComments && errors.mpcDryerComments
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    PACKAGING
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Comments
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='pwdPackagingComments'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.pwdPackagingComments}
                    error={
                      touched.pwdPackagingComments &&
                      !!errors.pwdPackagingComments
                    }
                    helperText={
                      touched.pwdPackagingComments &&
                      errors.pwdPackagingComments
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Pallets Produced (# Pallets - Product)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='pwdPalletsProduced'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.pwdPalletsProduced}
                    error={
                      touched.pwdPalletsProduced && !!errors.pwdPalletsProduced
                    }
                    helperText={
                      touched.pwdPalletsProduced && errors.pwdPalletsProduced
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Seal Checks Performed
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='pwdSealChecksPerformed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.pwdSealChecksPerformed}
                    error={
                      touched.pwdSealChecksPerformed &&
                      !!errors.pwdSealChecksPerformed
                    }
                    helperText={
                      touched.pwdSealChecksPerformed &&
                      errors.pwdSealChecksPerformed
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Seal Checks Failed
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='pwdSealChecksFailed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.pwdSealChecksFailed}
                    error={
                      touched.pwdSealChecksFailed &&
                      !!errors.pwdSealChecksFailed
                    }
                    helperText={
                      touched.pwdSealChecksFailed && errors.pwdSealChecksFailed
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Print Checks Performed
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='pwdPrintChecksPerformed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.pwdPrintChecksPerformed}
                    error={
                      touched.pwdPrintChecksPerformed &&
                      !!errors.pwdPrintChecksPerformed
                    }
                    helperText={
                      touched.pwdPrintChecksPerformed &&
                      errors.pwdPrintChecksPerformed
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Print Checks Failed
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='pwdPrintChecksFailed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.pwdPrintChecksFailed}
                    error={
                      touched.pwdPrintChecksFailed &&
                      !!errors.pwdPrintChecksFailed
                    }
                    helperText={
                      touched.pwdPrintChecksFailed &&
                      errors.pwdPrintChecksFailed
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Print Quality (1-4)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='pwdAvgPrintQuality'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.pwdAvgPrintQuality}
                    error={
                      touched.pwdAvgPrintQuality && !!errors.pwdAvgPrintQuality
                    }
                    helperText={
                      touched.pwdAvgPrintQuality && errors.pwdAvgPrintQuality
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    MPC PACKAGING
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Comments
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingComments'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingComments}
                    error={
                      touched.mpcPackagingComments &&
                      !!errors.mpcPackagingComments
                    }
                    helperText={
                      touched.mpcPackagingComments &&
                      errors.mpcPackagingComments
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Pallets Produced (# Pallets - Product)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPalletsProduced'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPalletsProduced}
                    error={
                      touched.mpcPalletsProduced && !!errors.mpcPalletsProduced
                    }
                    helperText={
                      touched.mpcPalletsProduced && errors.mpcPalletsProduced
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Seal Checks Performed
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcSealChecksPerformed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcSealChecksPerformed}
                    error={
                      touched.mpcSealChecksPerformed &&
                      !!errors.mpcSealChecksPerformed
                    }
                    helperText={
                      touched.mpcSealChecksPerformed &&
                      errors.mpcSealChecksPerformed
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Seal Checks Failed
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcSealChecksFailed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcSealChecksFailed}
                    error={
                      touched.mpcSealChecksFailed &&
                      !!errors.mpcSealChecksFailed
                    }
                    helperText={
                      touched.mpcSealChecksFailed && errors.mpcSealChecksFailed
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Print Checks Performed
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPrintChecksPerformed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPrintChecksPerformed}
                    error={
                      touched.mpcPrintChecksPerformed &&
                      !!errors.mpcPrintChecksPerformed
                    }
                    helperText={
                      touched.mpcPrintChecksPerformed &&
                      errors.mpcPrintChecksPerformed
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Print Checks Failed
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPrintChecksFailed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPrintChecksFailed}
                    error={
                      touched.mpcPrintChecksFailed &&
                      !!errors.mpcPrintChecksFailed
                    }
                    helperText={
                      touched.mpcPrintChecksFailed &&
                      errors.mpcPrintChecksFailed
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Print Quality (1-4)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcAvgPrintQuality'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcAvgPrintQuality}
                    error={
                      touched.mpcAvgPrintQuality && !!errors.mpcAvgPrintQuality
                    }
                    helperText={
                      touched.mpcAvgPrintQuality && errors.mpcAvgPrintQuality
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    GMP COMPLIANCE
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    # GMP Violations
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryGmpViolations'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryGmpViolations}
                    error={
                      touched.dryGmpViolations && !!errors.dryGmpViolations
                    }
                    helperText={
                      touched.dryGmpViolations && errors.dryGmpViolations
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Comments
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryGmpViolationComments'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryGmpViolationComments}
                    error={
                      touched.dryGmpViolationComments &&
                      !!errors.dryGmpViolationComments
                    }
                    helperText={
                      touched.dryGmpViolationComments &&
                      errors.dryGmpViolationComments
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    AUDIT TASKS
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Audit Date
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryAuditDate'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryAuditDate}
                    error={touched.dryAuditDate && !!errors.dryAuditDate}
                    helperText={touched.dryAuditDate && errors.dryAuditDate}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Audit Tasks Completed (By ID)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryAuditTasksCompleted'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryAuditTasksCompleted}
                    error={
                      touched.dryAuditTasksCompleted &&
                      !!errors.dryAuditTasksCompleted
                    }
                    helperText={
                      touched.dryAuditTasksCompleted &&
                      errors.dryAuditTasksCompleted
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    USDA Audit Tasks Completed (By ID)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryUsdaAuditTasksCompleted'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryUsdaAuditTasksCompleted}
                    error={
                      touched.dryUsdaAuditTasksCompleted &&
                      !!errors.dryUsdaAuditTasksCompleted
                    }
                    helperText={
                      touched.dryUsdaAuditTasksCompleted &&
                      errors.dryUsdaAuditTasksCompleted
                    }
                  />
                </Grid>
              </Grid>
              <ActionBar
                id={id}
                editOnly={true}
                values={values}
                setValues={setValues}
                record='superenddry'
                newToolTip='New Super End Dry Passdown'
              />
            </Form>
          </>
        )}
      </Formik>
    </>
  )
}

export default SuperMidDry
